import React, { useState, useEffect } from 'react';

const OptimizedImage = ({ 
  src, 
  webpSrc, 
  alt, 
  className = '', 
  loading = 'lazy',
  width,
  height,
  onLoad,
  onError 
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [supportsWebP, setSupportsWebP] = useState(false);

  useEffect(() => {
    // Check WebP support
    const checkWebPSupport = () => {
      const canvas = document.createElement('canvas');
      canvas.width = 1;
      canvas.height = 1;
      return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    };

    const webpSupported = checkWebPSupport();
    setSupportsWebP(webpSupported);
    
    // Set appropriate image source
    const targetSrc = webpSupported && webpSrc ? webpSrc : src;
    setImageSrc(targetSrc);
  }, [src, webpSrc]);

  const handleLoad = () => {
    setImageLoaded(true);
    if (onLoad) onLoad();
  };

  const handleError = () => {
    // Fallback to original format if WebP fails
    if (supportsWebP && imageSrc === webpSrc && src !== webpSrc) {
      setImageSrc(src);
    } else {
      setImageLoaded(true);
      if (onError) onError();
    }
  };

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={`transition-opacity duration-300 ${
        imageLoaded ? 'opacity-100' : 'opacity-0'
      } ${className}`}
      loading={loading}
      width={width}
      height={height}
      onLoad={handleLoad}
      onError={handleError}
    />
  );
};

export default OptimizedImage;